export default __webpack_public_path__ + "static/media/one.4ca6e76f.jpeg";